const CollectionPage = {
  init: async function () {
    if (!document.body.classList.contains('template-collection')) {
      return;
    }

    this.updateFreeShippingFilterVisibility();
    this.observeUrlChanges();
    this.observeFilterChanges();
    this.observeAjaxFilterChanges();
  },

  updateFreeShippingFilterVisibility: function () {
    const urlParams = new URLSearchParams(window.location.search);
    const hasPriceFilter = urlParams.has('filter.v.price.gte');
    this.updateFilterVisibility('.thb-filter-price-free-shipping-desktop', hasPriceFilter, 'desktop');
    this.updateFilterVisibility('.thb-filter-price-free-shipping-mobile', hasPriceFilter, 'mobile');
  },

  updateFilterVisibility: function (selector, hide, type) {
    const filter = document.querySelector(selector);
    if (!filter) {
      console.log(`Filtro ${type} no encontrado`);
      return;
    }

    if (hide) {
      filter.style.display = 'none';
      filter.setAttribute('data-hidden', 'true');
    } else {
      console.log(`Mostrando filtro de envío gratis (${type})`);
      filter.style.display = '';
      filter.removeAttribute('data-hidden');
    }
  },

  observeUrlChanges: function () {
    let lastUrl = location.href;
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        this.updateFreeShippingFilterVisibility();
      }
    }).observe(document, { subtree: true, childList: true });
  },

  observeFilterChanges: function () {
    console.log('Configurando observador de cambios en los filtros');
    const filterContainer = document.querySelector('.thb-filter-container');
    if (filterContainer) {
      const observer = new MutationObserver((mutations) => {
        this.updateFreeShippingFilterVisibility();
      });
      observer.observe(filterContainer, { childList: true, subtree: true });
    } else {
      console.log('No se encontró el contenedor de filtros');
    }
  },

  observeAjaxFilterChanges: function () {
    document.addEventListener('click', (event) => {
      const clickedFilter = event.target.closest('.thb-filter-price-free-shipping-desktop, .thb-filter-price-free-shipping-mobile');

      if (clickedFilter) {
        this.handleFilterClick();
      }
    });
  },

  handleFilterClick: function () {
    const checkAndUpdateFilters = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const hasPriceFilter = urlParams.has('filter.v.price.gte');

      this.updateFreeShippingFilterVisibility();

      if (hasPriceFilter) {
        clearInterval(checkInterval);
      }
    };

    // Comprobar inmediatamente
    checkAndUpdateFilters();

    // Continuar comprobando cada 100ms durante 2 segundos
    const checkInterval = setInterval(checkAndUpdateFilters, 100);
    setTimeout(() => clearInterval(checkInterval), 2000);
  },
};

// Inicializar la página de colección cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function () {
  CollectionPage.init();
});

function sleep(ms) {
  console.log(`sleep ${ms}`);
  return new Promise(resolve => setTimeout(resolve, ms));
}

// Asegurarse de que se actualice la visibilidad después de que la página se haya cargado completamente
window.addEventListener('load', function () {
  if (document.body.classList.contains('template-collection')) {
    CollectionPage.updateFreeShippingFilterVisibility();
  }
});

// Añadir un listener para el evento AJAX de Shopify
document.addEventListener('shopify:section:load', async function (event) {
  if (document.body.classList.contains('template-collection')) {

    console.log("price update");
    //Dormimos la ejecución durante 3 segundos
    await sleep(10000);
    CollectionPage.updateFreeShippingFilterVisibility();
  }
});

// Mobile: forzar que el drawer esté activo desde el inicio (sin animación)
(function () {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  if (!isMobile) return;

  function forceSearchDrawerActive() {
    const searchDrawer = document.getElementById('Search-Drawer');
    if (searchDrawer) {
      searchDrawer.classList.add('active');
      searchDrawer.style.transform = 'none';
      searchDrawer.style.opacity = '1';
      searchDrawer.style.visibility = 'visible';
      searchDrawer.style.display = 'block';
      searchDrawer.style.transition = 'none';
    }
  }

  // Ejecutar inmediatamente si el elemento ya existe
  if (document.getElementById('Search-Drawer')) {
    forceSearchDrawerActive();
  }

  // También ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceSearchDrawerActive);
  } else {
    forceSearchDrawerActive();
  }
})();

// Buscador de escritorio: predictive search en el input (sin abrir drawer)
(function () {
  function isDesktop() {
    return window.matchMedia('(min-width: 1068px)').matches;
  }
  function setup() {
    if (!isDesktop()) return;
    const container = document.querySelector('[data-desktop-search]');
    if (!container) return;
    const input = container.querySelector('.thb-desktop-search__input');
    const form = container.querySelector('.thb-desktop-search__form');
    const results = container.querySelector('.thb-desktop-search__results');

    const debounce = (fn, delay = 300) => {
      let t;
      return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), delay); };
    };

    function hideResults() {
      if (results) results.setAttribute('hidden', '');
    }
    function showResults() {
      if (results) results.removeAttribute('hidden');
    }
    function showRecommended() {
      const initial = document.querySelector('#Search-Drawer .side-panel-content--initial');
      if (initial && results) {
        results.innerHTML = `<div class="side-panel-content--initial">${initial.innerHTML}</div>`;
        showResults();
      }
    }
    function getQuery() {
      return (input?.value || '').trim();
    }
    function fetchResults(term) {
      if (!term) { hideResults(); return; }
      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(term)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
          if (!html) { hideResults(); return; }
          results.innerHTML = html.innerHTML;
          // Ajustar textos de botones dentro del dropdown
          results.querySelectorAll('.product-card--add-to-cart-text').forEach((el) => {
            el.textContent = 'Ver más..';
          });
          // En desktop, el HTML inyectado incluye un botón con id #search-results-submit
          // que en el drawer móvil dispara un submit mediante predictive-search.js.
          // Aquí debemos re-vincularlo al formulario de escritorio.
          const viewAllBtn = results.querySelector('#search-results-submit');
          if (viewAllBtn) {
            viewAllBtn.addEventListener('click', (e) => {
              e.preventDefault();
              if (form) {
                form.submit();
              }
            });
          }
          showResults();
        })
        .catch(() => { });
    }

    if (input) {
      input.addEventListener('input', debounce(() => fetchResults(getQuery()), 300));
      input.addEventListener('focus', () => {
        const q = getQuery();
        if (q) { fetchResults(q); } else { showRecommended(); }
      });
      input.addEventListener('click', () => {
        const q = getQuery();
        if (q) { fetchResults(q); } else { showRecommended(); }
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { hideResults(); input.blur(); }
      });
    }
    if (form) {
      form.addEventListener('submit', (e) => {
        if (!getQuery()) e.preventDefault();
      });
    }
    document.addEventListener('click', (e) => {
      if (!container.contains(e.target)) hideResults();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  window.addEventListener('resize', setup);
})();

(function () {
  const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';
  const CTA_SELECTOR = '#Search-Drawer .side-panel-content--initial .product-card--add-to-cart-text';
  const desktopQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);

  function updateSelectedForYouCtas() {
    const isDesktop = desktopQuery.matches;
    document.querySelectorAll(CTA_SELECTOR).forEach((el) => {
      const original = el.dataset.originalText || el.textContent.trim();
      if (!el.dataset.originalText) {
        el.dataset.originalText = original;
      }
      el.textContent = isDesktop ? 'Ver más' : el.dataset.originalText;
    });
  }

  function initSelectedForYouCtas() {
    updateSelectedForYouCtas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSelectedForYouCtas);
  } else {
    initSelectedForYouCtas();
  }

  document.addEventListener('shopify:section:load', initSelectedForYouCtas);
  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', updateSelectedForYouCtas);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(updateSelectedForYouCtas);
  }
})();

// Corregir badges que muestran "Productos" en lugar del porcentaje de descuento
(function() {
  function updateBadges() {
    const badges = document.querySelectorAll('.thb-predictive-search--promotion-products .badge.onsale, .thb-desktop-search__results .badge.onsale');
    badges.forEach(badge => {
      if (badge.textContent.trim() === 'Productos' || badge.textContent.trim().includes('Productos')) {
        const productCard = badge.closest('product-card');
        if (!productCard) return;
        
        const productLink = productCard.querySelector('a[href*="/products/"]');
        if (!productLink) return;
        
        const productHandle = productLink.href.match(/\/products\/([^\/\?]+)/)?.[1];
        if (!productHandle) return;
        
        fetch(`/products/${productHandle}.js`)
          .then(response => response.json())
          .then(product => {
            if (product.compare_at_price && product.price && product.compare_at_price > product.price) {
              const discountPercentage = Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100);
              badge.textContent = `${discountPercentage}% OFF`;
            }
          })
          .catch(() => {});
      }
    });
  }

  const observer = new MutationObserver(() => {
    updateBadges();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      updateBadges();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    updateBadges();
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
